<template>
  <v-main>
    <!-- <v-container class="py-2"> -->
      <NuxtPage />
    <!-- </v-container> -->
  </v-main>
</template>